import { createContext, useContext, useState } from "react";

const BuilderContext = createContext(null);
export const useBuilder = () => useContext(BuilderContext);

export function BuilderProvider({ children }) {
  const [tonic, setTonic] = useState("C");
  const [mode, setMode] = useState("Major");
  const [seq, setSeq] = useState([]);
  const [bpm, setBpm] = useState(100);
  const [bars, setBars] = useState(1);

  const loadProgression = (p) => {
    setTonic(p.tonic);
    setMode(p.mode);
    setSeq(p.chords || []);
    if (p.bpm) setBpm(p.bpm);
    if (p.bars) setBars(p.bars);
    document.getElementById("builder")?.scrollIntoView({ behavior: "smooth" });
  };
  const setKey = (t, m) => {
    setTonic(t);
    setMode(m);
    document.getElementById("builder")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <BuilderContext.Provider value={{ tonic, setTonic, mode, setMode, seq, setSeq, bpm, setBpm, bars, setBars, loadProgression, setKey }}>
      {children}
    </BuilderContext.Provider>
  );
}
